import React from 'react';
import {View} from 'react-native';

import Icon from '/component/base/Icon';
import Text from '/component/base/Text';

import {styles} from '../styles/VolPerfEmptyState.style';

export const VolPerfEmptyState = () => (
  <View style={styles.base}>
    <Icon name="info" style={styles.emptyIcon} />
    <Text emphasis="high" variant="xLarge" style={styles.emptyTitle}>
      Sorry, Empty
    </Text>
    <Text emphasis="high" variant="small" style={styles.emptyDescription}>
      Looks like this report is empty
    </Text>
  </View>
);

export default VolPerfEmptyState;
